module.exports = __webpack_public_path__ + "img/havefun_title-sc.2877cd1c.png";